module.exports = __webpack_public_path__ + "static/media/Engpic5.e5cd620f.png";